/**
 * `?brand=<business_id>` on any in-app URL makes that brand active when the
 * user belongs to it (PUSH_NOTIFICATIONS_PLAN.md ruling 11). A notification
 * about brand B, opened while brand A is active, would otherwise load B's
 * review page under A and 404.
 *
 * Two readers, one job each:
 * - `AccountProvider` reads it from `window.location` at its first resolve, so
 *   the page a notification opens fetches under the right brand from its
 *   first request;
 * - `BrandFromUrl`, inside the router, applies it on later in-app navigations
 *   and then removes it with a `replace` navigation, so the router's own
 *   location stays the source of truth.
 */
export const BRAND_PARAM = 'brand';

export function brandFromLocation(): string | null {
  try {
    return new URLSearchParams(window.location.search).get(BRAND_PARAM);
  } catch {
    return null;
  }
}
